import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import ProfileFormContainer from './ProfileFormContainer';
import Separator from '../../../core/layout/Separator';
import WebPageFormContainer from './WebPageFormContainer';
import VimeoVideoUploadDialogContainer from '../../../core/layout/VimeoVideoUploadDialogContainer';

const ProfileFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Profile',
        },
      ]}
    />
    <Card title="Your Profile">
      <ProfileFormContainer />
    </Card>
    <Separator size="md" />
    {props.showWebPageConfig && (
      <Card title="Your Web Page settings">
        <WebPageFormContainer />
      </Card>
    )}
    <VimeoVideoUploadDialogContainer />
  </div>
);

export default ProfileFormScene;
